import * as jose from 'jose';

export const isPiranhaToken = (token : string) => !!jose.decodeJwt(token).tefUserAssets;
